import { t } from "react-multi-lang";
import MyDialog from "../../../components/Dialog/dialog"




interface iProps{open:boolean,setOpen:Function,data:any}
const ClientDetail =({open,setOpen,data}:iProps)=>{


return (
    <MyDialog open={open} setOpen={setOpen}
    title={t("client_detail")} >
        {data}
    </MyDialog>
)

}
export default ClientDetail;